import React from 'react';
import PropTypes from 'prop-types';
import PaperclipIcon from 'mdi-react/PaperclipIcon';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
import FileSyncOutlineIcon from 'mdi-react/FileSyncOutlineIcon';
import { Row, Col, Tooltip } from 'antd';

const ImportShapefilesSecondStage = (props): JSX.Element => {
  const {
    matriculation, land, fileSuccess, fileErrors, renderFileName,
  } = props;

  return (
    <div className="first-col">
      <Row>
        <Col>
          <span className="green-span">BP: </span>
          <span>{matriculation.value}</span>
        </Col>
      </Row>

      <Row>
        <Col>
          <span className="green-span">Propriedade: </span>
          <span>{land.value}</span>
        </Col>
      </Row>

      <Row className="margin-top-20">
        <Col>
          <span className="green-span">Arquivos importados</span>
        </Col>
      </Row>

      <Row>
        <Col>
          {
            fileSuccess.map((element) => (
              <div key={element.file} className="shape-list">
                <PaperclipIcon />
                <div className="shape-list-info">
                  <Tooltip title={element.file}>
                    <span>{renderFileName(element.file)}</span>
                  </Tooltip>
                  <CheckCircleIcon color="#93bf4c" />
                </div>
              </div>
            ))
          }
        </Col>
      </Row>

      {
        fileErrors.length ? (
          <div>
            <Row className="margin-top-20">
              <Col>
                <span className="green-span">Arquivos não importados</span>
              </Col>
            </Row>
            <Row>
              <Col>
                {
                  fileErrors.map((element) => (
                    <div key={element.file} className="shape-list">
                      <PaperclipIcon color="#b3b3b3" />
                      <div className="shape-list-info">
                        <Tooltip title={element.file}>
                          <span style={{ color: '#b3b3b3' }}>
                            {renderFileName(element.file)}
                          </span>
                        </Tooltip>
                        <FileSyncOutlineIcon color="#b3b3b3" />
                      </div>
                    </div>
                  ))
                }
              </Col>
            </Row>
          </div>
        ) : null
      }
    </div>
  );
};

ImportShapefilesSecondStage.propTypes = {
  matriculation: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,

  land: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,

  fileSuccess: PropTypes.arrayOf(PropTypes.any).isRequired,
  fileErrors: PropTypes.arrayOf(PropTypes.any).isRequired,
  renderFileName: PropTypes.func.isRequired,
};

ImportShapefilesSecondStage.defaultProps = {};

export default ImportShapefilesSecondStage;
